// extracted by mini-css-extract-plugin
export var brand = "_3v-9";
export var compact = "_3v-6";
export var extraSmall = "_3v-7";
export var icon = "_3v-0";
export var large = "_3v-4";
export var light = "_3v-1";
export var medium = "_3v-5";
export var outline = "_3v-b";
export var primaryDark = "_3v-a";
export var primaryLight = "_3v-8";
export var primaryModern = "_3v-c";
export var success = "_3v-2";
export var successSolid = "_3v-3";